import { createContext, useState } from "react";

const ActionContext = createContext({});

export const ActionProvider = ({ children }) => {
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [previousPage, setPreviousPage] = useState("");

  return (
    <ActionContext.Provider
      value={{
        openCancelModal,
        setOpenCancelModal,
        previousPage,
        setPreviousPage,
      }}
    >
      {children}
    </ActionContext.Provider>
  );
};

export default ActionContext;
